<template>
  <el-dialog
    width="950px"
    title="通用查询"
    v-drag
    class="kye-dialog__modal-in-tab kye-custom-filter-group noselect"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="escape"
    :canResize="false"
    :showFullScreenButton="false"
    :visible.sync="show"
    @open="onOpen"
    @close="onClose">
    <div class="main-wrap">
      <div class="main-wrap_left">
        <el-autocomplete
          ref="templateFilter"
          v-model="templateKey"
          clearable
          placeholder="输入模板名称"
          class="tpl-popper"
          popper-class="kye-popper-auto"
          value-key="name"
          :trigger-on-focus="false"
          :fetch-suggestions="filterTemplate"
          @select="selectTemplate">
          <i slot="prefix" class="layout layout-search"></i>
        </el-autocomplete>
        <el-scrollbar>
          <draggable
            ref="draggable"
            tag="ul"
            class="tpl-list"
            v-if="templateList.length"
            v-bind="dragOptions"
            @end="draggableEnd"
            :list="templateList">
            <li class="tpl" v-for="(item, index) in templateList" :key="index">
              <el-checkbox v-show="!showBatchRemove" v-model="item._checked" style="margin-right: 8px;"></el-checkbox>
              <img class="tpl-list-icon" :src="require('./assets/custom-file.svg')" />
              <div
                class="name"
                :class="nameClass(index)"
                :title="item.name.length > 13 ? item.name : ''"
                @click="loadTemplate(index)">
                {{item.name}}
              </div>
              <el-dropdown
                class="tpl-more"
                v-show="model.templateIndex === index"
                @command="(val) => handleMore(val, index)"
                trigger="click">
                <div @click.stop>
                  <img class="tpl-more-img" src="./assets/custom-file-more.svg" />
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="updateTemplate">
                    <i class="layout layout-bianji" style="font-size: 12px;"></i>
                    重命名
                  </el-dropdown-item>
                  <el-dropdown-item command="removeTemplate">
                    <i class="layout layout-shanchu" style="font-size: 12px;"></i>
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
          </draggable>
          <div v-else class="tpl-empty">
            <img class="tpl-no-data-img" src="./assets/custom-filter-no-data.png"/>
            <span class="tpl-no-data-text">暂无数据</span>
          </div>
        </el-scrollbar>
      </div>
      <rule class="main-wrap_group" ref="rule" height="407" :module="module" :inner="true" />
    </div>
    <div slot="footer" class="kye-custom-filter-group__footer">
      <kye-button
        type="text"
        style="margin-left:4px;"
        v-show="!showBatchRemove"
        @click="removeTemplate(-1)">删除
      </kye-button>
      <kye-button
        type="text"
        style="margin-left:4px;"
        v-show="!showBatchRemove"
        @click="cancelRemove">取消
      </kye-button>
      <kye-button
        type="text"
        style="margin-left:0px;"
        auth="BTonkLNcnhiZ"
        class="layout layout-fenxiang"
        v-show="showBatchRemove"
        @click="showShareDialog">
      分享
      </kye-button>
      <el-dropdown @command="handleCommand" v-show="showBatchRemove" trigger="click">
        <kye-button
          type="text"
          style="margin-left:4px;"
          auth="BTonkLNcnhiZ"
          class="layout layout-a-gengduo3"
          > 更多
        </kye-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="showRemove" :disabled="templateList.length === 0">
            <i class="layout layout-piliangshanchu" style="font-size: 12px;"></i>
            批量删除
          </el-dropdown-item>
          <el-dropdown-item command="showImportDialog">
            <i class="layout layout-daoru" style="font-size: 12px;"></i>
            导入
          </el-dropdown-item>
          <el-dropdown-item command="exportRules">
            <i class="layout layout-export" style="font-size: 12px;"></i>
            导出
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span style="flex:1;"></span>
      <el-button
        type="primary"
        icon="layout layout-reset"
        v-if="model.genericId"
        @click="onReset">重置
      </el-button>
      <el-button
        type="primary"
        hotkey="ctrl+s"
        icon="layout layout-baocun"
        :disabled="!model.templateId"
        @click="saveTemplate">保存(S)
      </el-button>
      <el-button
        type="primary"
        icon="layout layout-lingcun"
        @click="createTemplate">另存为
      </el-button>
      <el-button
        type="primary"
        hotkey="ctrl+q"
        icon="layout layout-search1"
        @click="onQuery">查询(Q)
      </el-button>
      <el-button
        style="padding-left:20px;padding-right:20px;"
        @click="show = false">取消
      </el-button>
    </div>
    <name-dialog
      ref="nameDialog"
      :escape="escape"
      :model="model"
      @change="saveTemplate" />
    <import-dialog
      ref="importDialog"
      :escape="escape"
      @change="importRules" />
    <share-dialog
      v-if="hasShareAuth"
      ref="shareDialog"
      :escape="escape"
      :templates="templateList"
    />
  </el-dialog>
</template>

<script>
  import Draggable from 'vuedraggable'
  import keydownEvent from '../../utils/hotkey'
  import rule from './custom-filter-rule-group'
  import nameDialog from './template-name-dialog'
  import importDialog from './template-import-dialog'
  import shareDialog from './template-share-dialog'
  import { filterFieldsByAuthCode } from './utils'

  const EMPTY_LIST = []

  export default {
    name: 'custom-filter-group',
    components: { rule, nameDialog, importDialog, shareDialog, Draggable },
    props: {
      module: Object,
      initTemplate: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        show: false,
        showBatchRemove: true,
        templateKey: '',
        templateList: [],
        ruleOption: {},
        model: {
          esFlag: true,
          genericId: '',
          fields: null,
          templateId: '',
          templateName: '',
          templateIndex: -1
        },
        escape: true,
        dragOptions: {
          draggable: '.tpl',
          handle: '.tpl',
          animation: 150,
          filter: '.undraggable'
        }
      }
    },
    created () {
      this.initProps()
    },
    computed: {
      hasShareAuth () {
        return this.$store.getters.permission.menus.includes('BTonkLNcnhiZ')
      }
    },
    methods: {
      // 对外暴露，merge 查询条件
      setGenericFields (option) {
        this.ruleOption = option
      },
      setGenericSearchFields (obj) {
        if (obj && obj.columnList && obj.columnList.length) {
          this.model.genericId = obj.id
          this.model.esFlag = obj.esFlag === '10'
          obj.columnList = filterFieldsByAuthCode(obj.columnList, 'generic')
          obj.columnList.forEach(v => {
            v.key = this.model.esFlag ? v.propertyName : v.columnName
          })
          this.model.fields = obj.columnList
          this.mergeModule(this.model.fields)
          this.$emit('loaded', this.model)
          // query-table 通知加载模板
          if (this.initTemplate) {
            this.getTemplateList()
          }
        }
      },
      mergeModule (arr) {
        if (!this.module.option) {
          this.module.option = {}
        }
        arr.forEach(v => {
          // merge 前端的配置
          v.$attr = Object.assign(v.$attr || {}, this.module.option[v.key])
          // 后台扩展字段支持前端属性
          let attr = v.attribute2
          if (attr) {
            if (typeof attr === 'string') {
              try {
                attr = JSON.parse(attr)
              } catch (e) {
              }
            }
            if (typeof attr === 'object') {
              // 前端的配置覆盖模板的配置
              Object.assign(attr, v.$attr)
              Object.assign(v.$attr, attr)
            }
          }
        })
      },
      /**
       * 关闭弹窗
       */
      onClose () {
        this.saveRulesToLocal()
        document.removeEventListener('keydown', this.handleKeydown)
        this.show = false
        this.$emit('close')
      },
      /**
       * 打开弹窗, 设置通用查询字段
       */
      onOpen () {
        this.showBatchRemove = true
        this.resetTemplate()
        this.$nextTick(_ => {
          this.$refs.rule.setGenericFields(this.ruleOption)
          if (this.model.genericId) {
            this.$refs.rule.setGenericSearchFields(this.model.fields, this.model.esFlag)
            this.getTemplateList()
            this.getRulesFromLocal()
          }
          this.$emit('open')
        })
        // 通用查询弹框可能是在弹框里使用的，这种情况下hotkey查找dom的策略已失效
        document.addEventListener('keydown', this.handleKeydown)
      },
      /**
       * 查询
       */
      onQuery () {
        let obj = this.$refs.rule.onSubmit()
        if (!obj) {
          return
        }
        let vos = obj.vos // []
        let group = obj.group // {}
        let data = {
          elasticsearchFlag: this.model.esFlag ? 'Y' : 'N',
          generic: { vos },
          groupGeneric: { ...group }
        }
        let fn = this.module.beforeFormSubmit
        if (fn && typeof fn === 'function' && fn(data) === true) {
          return
        }
        this.queryLog_zh_cn = this.getQueryLog_zh_cn()
        this.$emit('submit', data, this.queryLog_zh_cn)
        this.show = false
      },
      initProps () {
        if (!this.module.method || !this.module.searchCode) {
          let msg = 'custom-filter 组件配置错误：method, searchCode 为必选项'
          this.$alert(msg, '提示', { type: 'error', showClose: false })
          return
        }
        if (this.module.sectionOption) {
          this.module.sectionOption.$row = `$${this.module.sectionOption.row}`
        }
        if (!this.module.module) {
          this.module.module = this.module.method
        }
      },
      handleKeydown (e) {
        if (this.$el && (!this.$refs.nameDialog || !this.$refs.nameDialog.show)) {
          keydownEvent(e, this.$el.querySelector('.kye-custom-filter-group__footer'))
        }
      },
      /**
       * 获取缓存搜索条件
       */
      getRulesFromLocal () {
        let res = localStorage.getItem('GLOBAL_SEARCH_GENERIC_GROUP')
        if (res) {
          try {
            let tag = `${this.$route.meta.tag}?${this.module.module}`
            res = JSON.parse(res)
            res = res[tag]
            if (res && Array.isArray(res)) {
              this.$refs.rule.setRules(res)
            }
          } catch (e) {
          }
        }
      },
      /**
       * 缓存搜索后的条件
       */
      saveRulesToLocal () {
        let rules = this.$refs.rule.getValidRules()
        if (rules) {
          const name = 'GLOBAL_SEARCH_GENERIC_GROUP'
          let res = localStorage.getItem(name)
          let tag = `${this.$route.meta.tag}?${this.module.module}`
          if (res) {
            try {
              res = JSON.parse(res)
              res[tag] = rules
              localStorage.setItem(name, JSON.stringify(res))
            } catch (e) {
            }
          } else {
            res = { [tag]: rules }
            localStorage.setItem(name, JSON.stringify(res))
          }
        }
      },
      // 获取dom里非隐藏的input的value
      getActiveInputValue (dom) {
        return Array.from(dom.querySelectorAll('.el-input__inner'))
          .map(t => t.value && t.clientWidth ? t.value : '')
          .join(' ')
      },
      getQueryLog_zh_cn () {
        let el = this.$refs.rule && this.$refs.rule.$el
        if (!el) {
          return ''
        }
        let arr = []
        el.querySelectorAll('.el-table__row').forEach(tr => {
          // tr 包含有非隐藏的 el-select multiple
          let tags = tr.querySelectorAll('.el-select__tags-text')
          if (tags.length && tags[0].offsetWidth) {
            let text = Array.from(tr.childNodes).map((td, i) => {
              // 条件值td 包含有 el-select multiple
              if (i === 3) {
                // 通过正常的文本抓取不到正确的tags，通用查询的多选下拉框单独提供labels属性
                return Array.from(td.querySelectorAll('.el-select')).map(t => t.getAttribute('labels')).join('')
              }
              return this.getActiveInputValue(td)
            })
            arr.push(text.join(' '))
          } else {
            arr.push(this.getActiveInputValue(tr))
          }
        })
        return arr.join(' ').replace(/\s{2,}/g, ' ')
      },
      /**
       * 搜索筛选模板
       */
      filterTemplate (val, cb) {
        if (!this.templateList.length || !val || val.length < 2) {
          cb(EMPTY_LIST)
          return
        }
        let arr = this.templateList.filter(v => v.name && v.name.includes(val))
        cb(arr)
        // 自动选择第一行
        this.$nextTick(_ => {
          arr.length && this.$refs['templateFilter'].highlight && this.$refs['templateFilter'].highlight(0)
        })
      },
      /**
       * 选择模板
       */
      selectTemplate (val) {
        if (val) {
          let index = this.templateList.findIndex(v => val.id === v.id)
          this.loadTemplate(index)
          this.templateKey = ''
        }
      },
      handleCommand (command) {
        this[command]()
      },
      showRemove () {
        this.templateIndex = -1
        this.resetTemplate()
        this.showBatchRemove = false
      },
      cancelRemove () {
        this.showBatchRemove = true
        this.templateList = this.resetTemplateList(this.templateList)
      },
      resetTemplateList (arr) {
        return arr.map(v => ({ ...v, _checked: false }))
      },
      nameClass (index) {
        return {
          'is-active': this.model.templateIndex === index,
          'is-batch': !this.showBatchRemove
        }
      },
      /**
       * 加载模板
       */
      loadTemplate (index) {
        // 批量操作时，不允许加载列表
        if (!this.showBatchRemove) {
          return
        }

        let template = this.templateList[index]
        template.columnList.sort((a, b) => a.rowIndex - b.rowIndex)
        this.model.templateIndex = index
        this.model.templateId = template.id
        this.model.templateName = template.name
        let rules = template.columnList.map(v => ({
          propertyName: v.propertyName,
          columnName: v.columnName,
          frontBrackets: v.frontBrackettemplates,
          postBrackets: v.postBrackets,
          conditionOperation: v.conditionOperation,
          operation: v.operation,
          queryValue: v.queryValue,
          extJson: v.extJson
        }))
        this.$refs.rule.setRules(rules)
        this.$refs.rule.$el.querySelector('.kye-filter-rule-group-body').scrollTo({ top: 0, behavior: 'smooth' })
      },
      /**
       * 编辑模板名
       */
      updateTemplate (index) {
        let template = this.templateList[index]
        this.model.templateIndex = index
        this.model.templateId = template.id
        this.model.templateName = template.name
        this.showNameDialog()
      },
      /**
       * 移除模板
       */
      async removeTemplate (index) {
        const isBatch = index === -1
        const msg = isBatch ? '是否批量删除？' : '是否删除模板？'
        const templateList = this.templateList
        let ids = isBatch
        ? templateList.filter(v => v._checked).map(v => v.id)
        : [templateList[index].id]
        if (isBatch && ids.length === 0) {
          this.$message.warning('请选择需要删除的数据！')
          return
        }
        await this.$confirm(msg, '提示')
        await this.$http('system.genericSearch.template.delete', { ids })
        if (isBatch) {
          for (let i = templateList.length - 1; i >= 0; i--) {
            const item = templateList[i]
            item._checked && templateList.splice(i, 1)
          }
        } else {
          templateList.splice(index, 1)
          this.resetTemplate()
        }
        if (!templateList.length) this.cancelRemove()
        this.$message.success('删除成功')
      },
      handleMore(val, index) {
        this[val](index)
      },
      /**
       * 重置模板选中状态
       */
      resetTemplate () {
        this.model.templateId = ''
        this.model.templateName = ''
        this.model.templateIndex = -1
      },
      /**
       * 保存模板
       */
      async saveTemplate () {
        let vos = this.$refs.rule.onSubmit()
        if (!vos) {
          return
        }
        let data = {
          name: this.model.templateName,
          genericId: this.model.genericId,
          columnList: this.$refs.rule.mapColumnList()
        }
        if (this.model.templateId) {
          data.id = this.model.templateId
        }
        await this.$http('system.genericSearch.template.saveOrUpdate', data)
        if (this.model.templateId && data.columnList) {
          this.templateList[this.model.templateIndex].name = this.model.templateName
          this.templateList[this.model.templateIndex].columnList = data.columnList
        } else {
          this.getTemplateList()
        }
        this.resetTemplate()
        this.$message.success('保存模板成功')
      },
      /**
       * 获取模板列表
       */
      async getTemplateList () {
        let data = { genericId: this.model.genericId }
        const list = await this.$http('system.genericSearch.template.listByGenericId', data)
        this.templateList = this.resetTemplateList(list)
        this.$emit('onTemplateListChange', this.templateList)
      },
      /**
       * 另存为模板
       */
      createTemplate () {
        this.resetTemplate()
        let vos = this.$refs.rule.onSubmit()
        if (vos) {
          this.showNameDialog()
        }
      },
      /**
       * 模板名弹窗
       */
      showNameDialog (val = true) {
        if (this.$refs.nameDialog) {
          this.$refs.nameDialog.show = val
        }
      },
      /**
       * 导入模板
       */
      importRules (rules) {
        this.$refs.rule.setRules(rules)
      },
      /**
       * 导入弹窗
       */
      showImportDialog () {
        if (this.$refs.importDialog) {
          this.$refs.importDialog.show = true
        }
      },
      /**
       * 导出
       */
      async exportRules () {
        let vos = this.$refs.rule.onSubmit()
        if (vos) {
          try {
            await this.$confirm('是否将通用查询条件下载到当前文档?', '提示')
            let rules = this.$refs.rule.getValidRules()
            let elink = document.createElement('a')
            elink.download = 'genericSearchRules.txt'
            elink.style.display = 'none'
            let blob = new Blob([JSON.stringify(rules)])
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            document.body.removeChild(elink)
          } catch (e) {
            console.log(e)
          }
        }
      },
      /**
       * 分享模板弹窗
       */
      showShareDialog () {
        if (this.$refs.shareDialog) {
          this.$refs.shareDialog.show = true
        }
      },
      /**
       * 重置模板
       */
      onReset () {
        this.$refs.rule.setGenericSearchFields(this.model.fields, this.model.esFlag)
        let res = localStorage.getItem('GLOBAL_SEARCH_GENERIC_GROUP') || '{}'
        let tag = `${this.$route.meta.tag}?${this.module.module}`
        res = JSON.parse(res)
        delete res[tag]
        localStorage.setItem('GLOBAL_SEARCH_GENERIC_GROUP', JSON.stringify({...res}))
        this.$emit('reset', { vm: this.$refs.rule })
      },
      async draggableEnd () {
        try {
          let templateList = this.templateList.map((v, index) => ({ id: v.id, displaySequence: index }))
          await this.$http('system.genericSearch.template.update.sort', { templateList })
        } catch (e) {
          console.log(e)
        }
      }
    }
  }
</script>

<style lang="scss">
  .kye-custom-filter-group > div > .el-dialog__body {
      padding: 16px 0 16px 16px;
      overflow: hidden;
  }
  .kye-custom-filter-group {
    .el-dialog__header,
    .el-dialog__footer {
      border-color:#e6e6e6;
    }
    .main-wrap {
      display: flex;
      flex-wrap: nowrap;
      &_left {
        width: 240px;
        margin-right: 8px;
        border: 1px solid #E9E8ED;
        border-radius: 4px;
        .tpl-popper {
          // padding: 8px 12px;
          padding: 8px 12px;
          // border-bottom: 1px solid #e9e9e9;
          .el-input__inner {
            // padding-left: 26px!important;
            // border-radius: 2px;
            // padding-left: 24px !important;
            // padding-right: 6px !important;
            padding: 0px 8px 0px 26px !important;
            border-radius: 4px;
            color: #333333;
            border-color: #DCDCDC;
            background-color: #ffffff;
          }
          .el-input__prefix {
            top: 6px;
            padding-left: 4px;
            font-size: 12px;
            color: #b2b2b2;
          }
        }
        .tpl-list {
          overflow: auto;
          // .center {
          //   margin-top: 10px;
          // }
          .tpl-list-icon {
            width: 12px;
            height: 12px;
          }
          .tpl {
            display: flex;
            align-items: center;
            height: 24px;
            padding: 0 12px;
            // height: 40px;
            // display: flex;
            // align-items: center;
            // padding: 0 16px;
            // &-index {
            //   padding: 0 4px;
            //   height: 28px;
            //   line-height: 28px;
            //   min-width: 28px;
            //   transform:scale(0.5, 0.5);
            //   border: 1px solid #979797;
            //   border-radius: 3px;
            //   text-align: center;
            //   font-size: 12px;
            //   color: #999;
            // }
            &:hover {
              background-color: #f1f1f5;
            }
            // &.is-active, &:hover {
            //   background: rgba(0, 0, 0, 0.1);
            // }
            .name {
              flex: 1;
              max-width: calc(100% - 18px);
              margin-left: 4px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow-x: hidden;
              cursor: pointer;
              font-size: 12px;
              color: #333;
              // margin-left: 4px;
            }
            .tpl-more {
              cursor: pointer;
              .tpl-more-img {
                vertical-align: middle;
              }
            }
            .el-icon-edit {
              color: var(--g-color-primary);
              cursor: pointer;
            }
            .el-icon-delete {
              cursor: pointer;
            }
            // .el-icon-delete, .el-icon-edit {
            //   color: var(--g-color-primary);
            //   cursor: pointer;
            //   margin-left: 10px;
            // }
            .is-active {
              // max-width: 126px;
              color: #ff9300;
              font-weight: 600;
            }
            .is-batch {
              max-width: 136px;
            }
          }
        }
        .tpl-empty {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding-top: 80px;
          .tpl-no-data-img {
            width: 80px;
            height: 60px; // 避免图片加载时布局抖动
          }
          .tpl-no-data-text {
            line-height: 16px;
            font-size: 12px;
            color: #999;
          }
        }
        .el-scrollbar {
          // height: 270px;
          height: 389px;
        }
        .el-scrollbar__wrap {
          height: 100%;
          overflow: auto;
          margin-right: 0px !important;
          overflow-x: hidden;
          &::-webkit-scrollbar {
            width: 0px;
            height: 0px;
          }
        }
        .el-scrollbar__bar.is-horizontal {
          display: none;
        }
      }
      &_group {
        flex: 1;
      }
    }
    &__footer {
      display: flex;
      .main-btn {
        .layout {
          font-weight: normal;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/query-table/custom-filter-group.vue